const demo_app = {
    notification: 'İpucu: Oturum açma deneyimini test etmek için önce bir hesap oluşturun.',
};
export default Object.freeze(demo_app);
